// @flow

import statusFormatter from './status.formatter';
import type { FormatterArgs } from '../../../types';

const formatters = (args?: FormatterArgs): Array<any> =>
  [statusFormatter].map(formatter => formatter(args));

export default formatters;
